import React from 'react';
import { motion } from 'framer-motion';

const systems = ['SaaS Platforms', 'Enterprise Backends', 'Media Hosting Systems', 'Subscription Commerce'];

const SystemsV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-gray-50 border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-8">Systems Delivered</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {systems.map((item, i) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              viewport={{ once: true }}
              className="rounded-xl bg-white p-5 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300 text-center font-semibold text-gray-800"
            >
              {item}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SystemsV3;
